interface ComposerCaretEditor {
  state: {
    selection: { from: number };
    doc: {
      textBetween: (
        from: number,
        to: number,
        blockSeparator?: string,
        leafText?: string
      ) => string;
    };
  };
}

/** Text sitting in the composer immediately before the caret, including the `@`. */
export function textBeforeComposerCaret(editor: ComposerCaretEditor): string {
  const from = editor.state.selection.from;
  return editor.state.doc.textBetween(Math.max(0, from - 48), from, ' ', ' ');
}

/**
 * An add-patient sentence (`Add @`, `for @`, `onto @`) is choosing a person.
 * A bare `@` still lists sessions and patients together.
 */
export function textPrefersPatientMention(textBeforeCaret: string): boolean {
  return /(?:\bAdd|\bfor|\bonto)\s@[^@]*$/i.test(textBeforeCaret);
}
